import { render, staticRenderFns } from "./GeneralHeader.vue?vue&type=template&id=1ded5c69&scoped=true"
import script from "./GeneralHeader.vue?vue&type=script&lang=js"
export * from "./GeneralHeader.vue?vue&type=script&lang=js"
import style0 from "./GeneralHeader.vue?vue&type=style&index=0&id=1ded5c69&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ded5c69",
  null
  
)

export default component.exports